/**
 * Login Layout
 * renders the layout for login
 */
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import template from '@/../templates/ide-login-layout-template.hbs';


    var globalCh = Radio.channel('global');

    export default Marionette.View.extend({
        initialize: function(options){
            this.options = (options || {});
        },
        template: Handlebars.compile(template),
        templateContext: function(){
            // app_options we will extend and pass to the template
            var app_options = globalCh.request('app_options');

            if ( app_options.features && app_options.features.environment_name ) {
                this.options.env_name = app_options.features.environment_name;
            }

            this.options.powered_by = app_options.features && app_options.features.powered_by;

            return (this.options);
        },        
        regions : {
            content : '#right-account-container .content-container',
            alerts  : '#alerts',
            dialogs : '#dialogs'
        }
    });

